/**
 * On-Balance Volume (OBV)
 *
 * Cumulative volume indicator: adds volume on up-days and subtracts on
 * down-days.  Used to detect divergences between price and volume flow.
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const obvIndicator: IndicatorDefinition = {
  id: "obv",
  name: "On Balance Volume",
  shortName: "OBV",
  category: "volume",
  pane: "separate",
  params: [
    { key: "color", label: "Color", type: "color", default: "#42A5F5" },
  ],
  plots: [
    { key: "obv", label: "OBV", color: "#42A5F5", style: "line", lineWidth: 2, priceScaleId: "obv" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const data: { time: number; value: number }[] = [];

    if (candles.length === 0) return [{ key: "obv", data }];

    let obv = candles[0].volume || 0;
    data.push({ time: candles[0].time, value: obv });

    for (let i = 1; i < candles.length; i++) {
      const vol = candles[i].volume || 0;
      if (candles[i].close > candles[i - 1].close) {
        obv += vol;
      } else if (candles[i].close < candles[i - 1].close) {
        obv -= vol;
      }
      // Equal close = no change
      data.push({ time: candles[i].time, value: obv });
    }

    return [{ key: "obv", data }];
  },
};
